export enum RedirectParamKey {
  Code = 'code',
  State = 'state',
  Error = 'error',
}
